import { ExternalImage as ExternalImageType } from '@/schemas/sceneDataSchema';
import { styled } from '@mui/material';
import { useState } from 'react';

export const ExternalImage: React.FC<Omit<ExternalImageType, 'type'>> = ({ src, alt, width, margin }) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  if (!src) {
    return null;
  }

  return (
    <picture style={{ display: 'contents' }}>
      <Img
        src={src}
        alt={alt ?? undefined}
        onLoad={() => setIsLoaded(true)}
        imgWidth={width ? `${width}px` : '100%'}
        imgMargin={margin ?? '0'}
        isLoaded={isLoaded}
      />
    </picture>
  );
};

interface ImgProps {
  imgWidth: string;
  imgMargin: string;
  isLoaded: boolean;
}

const Img = styled('img')<ImgProps>`
  display: block;
  width: ${(props) => props.imgWidth};
  margin: ${(props) => props.imgMargin};
  height: auto;
  transition: opacity 0.5s ease-out;
  opacity: ${(props) => (props.isLoaded ? 1 : 0)};
`;
